module.exports = __webpack_public_path__ + "img/itx-file-type-ics.97be7d75.svg";